import axios from 'axios';
import React, {useEffect, useState} from 'react';
import { useHistory,useParams } from 'react-router-dom';
import styled from 'styled-components';
import './Detail.scss';

let box1 = styled.div`
    padding : 20px;
`;

let myTitle = styled.h4`
  font-size : 25px;
`;

function Detail(props){
    let [alert,setAlert] = useState(true);
    let [inputNumber, setInputNumber] = useState('');
    
    useEffect(()=>{
        // axios.get();
        let timer = setTimeout(()=>{  setAlert(false) },2000);
        return ()=>{clearTimeout(timer)}
    },[]); //only for... BLANK means only for on appear

    // useEffect(()=>{}); one more useEffect available

    let {id} = useParams();
    let history = useHistory();
    let finded = props.shoe.find(function(product){
        return product.id == id
      });

    return(
        <div className="container">
            <box1>
                <myTitle className="red">Detail Page</myTitle>
            </box1>
            <br/>

            {/* {inputNumber} */}
            <input onChange={(e)=>{setInputNumber(e.target.value)}}/>

            {
                alert?
                (<div className="my-alert2">
                    <p>재고가 얼마남지 않았습니다.</p>
                </div>)
                : null
            }
            <div className="row">
            <div className="col-md-6">
                <img src={'https://codingapple1.github.io/shop/shoes'+(Number(id)+1)+'.jpg'} width="100%" />
            </div>
            <div className="col-md-6 mt-4">
                <h4 className="pt-5">{finded.title}</h4>
                <p>{finded.content}</p>
                <p>{finded.price}</p>

                <Info stock={props.stock}></Info>


                <button className="btn btn-danger" onClick={()=>{
                    props.setStock([9,10,11]);
                }}>주문하기</button> 
                <button className="btn btn-danger" onClick={()=>{
                    history.goBack();
                }}>뒤로하기</button> 
            </div>
            </div>
        </div> 
    )
}

function Info(props){
    return(
        <p>재고 : {props.stock[0]}</p>
    )
}

export default Detail;